(function(){
  const $=s=>document.querySelector(s), $$=s=>Array.from(document.querySelectorAll(s));
  const cfg=$('#hp-data'); if(!cfg) return;
  /* translations come from the theme locale files (hp.js.*) */
  const I=(()=>{ try{ return JSON.parse(($('#hp-i18n')||{}).textContent||'{}'); }catch(e){ return {}; } })();
  const deco=document.createElement('textarea');
  const L=(k,d,v)=>{ let s=d; const t=I[k]; if(t&&!/^translation missing/i.test(t)){ deco.innerHTML=t; s=deco.value; } if(v) for(const x in v) s=s.split('{'+x+'}').join(v[x]); return s; };
  const LIVE=!!(window.Shopify&&window.Shopify.routes);
  const ROOT=LIVE?(window.Shopify.routes.root||'/'):'/';
  const CUR=cfg.dataset.currency||'EUR';
  const LANG=String(cfg.dataset.locale||document.documentElement.lang||'en').slice(0,2).toLowerCase();
  const INTL={en:'en-IE',es:'es-ES',nl:'nl-NL',fr:'fr-FR',de:'de-DE'}[LANG]||LANG;
  const RATE=(LIVE&&window.Shopify.currency&&Number(window.Shopify.currency.rate))||1;
  const SHIP=CUR==='EUR'?299:0; /* tracked shipping: 2,99 EUR per order; other currencies see the cost at checkout */
  const REDUCE=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MQ_PHONE=window.matchMedia('(max-width: 899px)');
  const MQ_DESK=window.matchMedia('(min-width: 900px)');
  const MQ_SHEET=window.matchMedia('(max-width: 640px)');
  const clamp=(v,a,b)=>Math.min(b,Math.max(a,v));
  let NF; try{ NF=new Intl.NumberFormat(INTL,{style:'currency',currency:CUR}); }catch(e){ NF=null; }
  const money=c=>NF?NF.format(c/100):(c/100).toFixed(2)+' '+CUR;
  const esc=s=>{const d=document.createElement('div');d.textContent=s==null?'':String(s);return d.innerHTML;};
  const buzz=ms=>{ try{ if(navigator.vibrate) navigator.vibrate(ms); }catch(e){} };
  const lock=on=>document.documentElement.classList.toggle('is-locked',on);
  let popOpen=null;
  const anyOpen=()=>{ const d=$('#drawer'), m=$('#mnav'), lb=$('#lb'); return (d&&d.classList.contains('open'))||(m&&!m.hidden)||(lb&&!lb.hidden)||!!(popOpen&&popOpen.classList.contains('is-sheet')); };

  /* ---------- products: the tag (pack x collar) and the advent calendar (dog or cat) ---------- */
  let P={}; try{ P=JSON.parse(($('#hp-products')||{}).textContent||'{}')||{}; }catch(e){ P={}; }
  const ok=p=>p&&Array.isArray(p.v)&&p.v.length;
  const TAG=ok(P.tag)?P.tag:null, CAL=ok(P.cal)?P.cal:null;
  if(TAG) TAG.v.forEach(v=>{
    const m=String(v.sku||'').toUpperCase().match(/TAG-(\d+)-(DM|DL|C)\b/);
    if(m){ v.pack=+m[1]; v.collar=m[2]; return; }
    const t=String(v.t||''); v.pack=+((t.match(/\d+/)||[1])[0]);
    v.collar=/cat|gato|chat|kat/i.test(t)?'C':(/\bL\b/.test(t)?'DL':'DM');
  });
  if(CAL) CAL.v.forEach(v=>{ const s=String(v.sku||'').toUpperCase()+' '+String(v.t||''); v.pet=/CAT|GATO|CHAT|KAT/i.test(s)?'cat':'dog'; });
  const VMAP={}; [TAG,CAL].forEach(p=>{ if(p) p.v.forEach(v=>{ VMAP[v.id]={v,p}; }); });
  const tagV=(pack,collar)=>TAG&&(TAG.v.find(v=>v.pack===pack&&v.collar===collar)||TAG.v.find(v=>v.pack===pack)||TAG.v[0]);
  const calV=pet=>CAL&&(CAL.v.find(v=>v.pet===pet)||CAL.v[0]);
  const PACK_PRICE=n=>{ const v=TAG&&TAG.v.find(x=>x.pack===n); return v?v.price:0; };
  const ONE=PACK_PRICE(1), TWO=PACK_PRICE(2);
  const PER_MIN=TAG?Math.min(...TAG.v.map(v=>Math.round(v.price/Math.max(1,v.pack)))):0;
  const COLLAR_LABEL={DM:L('c_dm','Dog, size M'),DL:L('c_dl','Dog, size L'),C:L('c_c','Cat')};
  const COLLAR_SUB={DM:L('c_dm_s','Neck 35–50 cm'),DL:L('c_dl_s','Neck 40–60 cm'),C:L('c_c_s','One size, safety buckle')};
  const packLabel=n=>n>1?L('pack2','{n} tags',{n}):L('pack1','1 tag');
  const PET_OF=c=>c==='C'?'cat':'dog';

  const qs=new URLSearchParams(location.search);
  const st={pack:1,collar:'DM',calFor:'dog',addon:false,afor:null};
  const qc=(qs.get('collar')||'').toLowerCase();
  if(qc==='cat') st.collar='C'; else if(qc==='dog-l'||qc==='l') st.collar='DL';
  if(qs.get('pack')==='2') st.pack=2;
  if(qs.get('for')==='cat'||(!qs.get('for')&&qc==='cat')) st.calFor='cat';
  try{ const qv=Number(qs.get('variant')); if(qv&&VMAP[qv]){ const x=VMAP[qv]; if(x.p===TAG){ st.pack=x.v.pack; st.collar=x.v.collar; } else st.calFor=x.v.pet; } }catch(e){}
  if(!qs.get('for')&&qc!=='dog'&&$('.xmas .dog-soon')) st.calFor='cat';
  const BUYKIND=(($('#buy')||{}).dataset||{}).buy||'';
  const ONTAG=BUYKIND==='tag', ONCAL=BUYKIND==='cal';
  const TAGURL=(TAG&&TAG.url)||cfg.dataset.home||'/';
  const HOMEURL=cfg.dataset.home||'/';

  function countTo(el,to){
    if(!el) return;
    const from=el.dataset.v!==undefined?Number(el.dataset.v):to; el.dataset.v=to;
    if(REDUCE||from===to){ el.textContent=money(to); return; }
    const t0=performance.now(), d=420;
    const step=now=>{ const p=Math.min(1,(now-t0)/d), e=1-Math.pow(1-p,3); el.textContent=money(Math.round(from+(to-from)*e)); if(p<1) requestAnimationFrame(step); };
    requestAnimationFrame(step);
  }

  /* prices printed around the page */
  function fillPrices(){
    if(TAG){
      $$('[data-from="tag"]').forEach(el=>{ el.textContent=el.classList.contains('js-from-cap')?L('from_cap','From {p}',{p:money(PER_MIN)}):L('from','from {p}',{p:money(PER_MIN)}); });
      $$('[data-min="tag"]').forEach(el=>{ el.textContent=money(PER_MIN); });
      $$('[data-price="tag"]').forEach(el=>{ el.textContent=money(ONE); });
    }
    if(CAL){
      const c=calV(st.calFor);
      $$('[data-from="cal"],[data-price="cal"]').forEach(el=>{ el.textContent=money(c.price); });
      $$('[data-cal-price]').forEach(el=>{ el.textContent=money(c.price); });
      $$('[data-cal-half]').forEach(el=>{ el.textContent=L('with_two','{p} with two tags',{p:money(Math.round(c.price/2))}); });
    }
  }

  /* ---------- tag: pack cards, collar cards, calendar add-on ---------- */
  const dots=n=>`<span class="p-dots" aria-hidden="true">${'<i></i>'.repeat(n)}</span>`;
  const ICON={dog:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9.5 3.5 6l3.5-1.5L9 7h6l2-2.5L20.5 6 19 9.5V15a5 5 0 0 1-5 5h-4a5 5 0 0 1-5-5z"/><circle cx="9.5" cy="12" r=".9" fill="currentColor"/><circle cx="14.5" cy="12" r=".9" fill="currentColor"/><path d="M11 16h2"/></svg>',
    cat:'<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 4l4 4h6l4-4v10a7 7 0 0 1-14 0z"/><circle cx="9.5" cy="12.5" r=".9" fill="currentColor"/><circle cx="14.5" cy="12.5" r=".9" fill="currentColor"/><path d="M11 16h2M3 14h3M3 17h3M18 14h3M18 17h3"/></svg>'};
  function renderPacks(){
    const box=$('#packList'); if(!box||!TAG) return;
    const packs=[...new Set(TAG.v.map(v=>v.pack))].sort((a,b)=>a-b);
    box.innerHTML=packs.map(n=>{
      const price=PACK_PRICE(n), per=Math.round(price/n), save=ONE*n-price, on=n===st.pack;
      const tag=n>1&&CAL?`<span class="b-tag">${esc(L('pack2_tag','Calendar half price'))}</span>`:'';
      const sub=n>1?L('per_tag','{p} per tag',{p:money(per)}):L('pack1_s','Tag fitted to its collar');
      return `<label class="bundle pack${on?' is-on':''}"><input type="radio" name="pack" value="${n}"${on?' checked':''}><span class="b-dot" aria-hidden="true"></span><span><span class="b-title">${esc(packLabel(n))}</span>${tag}<span class="b-per">${esc(sub)}</span>${dots(n)}</span><span class="b-price">${money(price)}${save>0?`<span class="b-save">${esc(L('save','Save {p}',{p:money(save)}))}</span>`:''}</span></label>`;
    }).join('');
  }
  function renderCollars(){
    const box=$('#collarList'); if(!box||!TAG) return;
    const codes=['DM','DL','C'].filter(c=>TAG.v.some(v=>v.collar===c));
    box.innerHTML=codes.map(c=>{ const on=c===st.collar, v=tagV(st.pack,c), out=v&&!v.available;
      return `<label class="collar${on?' is-on':''}${out?' is-out':''}"><input type="radio" name="collar" value="${c}"${on?' checked':''}${out?' disabled':''}><span class="c-ico">${ICON[PET_OF(c)]}</span><span class="c-txt"><b>${esc(COLLAR_LABEL[c])}</b><small>${esc(out?L('sold_out','Sold out'):COLLAR_SUB[c])}</small></span></label>`; }).join('');
  }
  function syncTag(){
    if(!TAG) return;
    const v=tagV(st.pack,st.collar);
    $$('.bundle.pack').forEach(l=>{ const on=Number(l.querySelector('input').value)===st.pack; l.classList.toggle('is-on',on); l.querySelector('input').checked=on; });
    $$('.collar').forEach(l=>{ const on=l.querySelector('input').value===st.collar; l.classList.toggle('is-on',on); l.querySelector('input').checked=on; });
    const note=$('#collarNote'); if(note) note.hidden=st.pack<2;
    const addon=$('#addon');
    if(addon&&CAL){
      addon.hidden=false;
      const pet=st.afor||PET_OF(st.collar), c=calV(pet), half=st.pack>1;
      $$('[data-afor]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.afor===pet)));
      const pr=$('#addonPrice'); if(pr) pr.innerHTML=`<b>${money(half?Math.round(c.price/2):c.price)}</b>`;
      const sub=$('#addonSub'); if(sub) sub.textContent=half?L('addon_half','Half price with two tags, applied at checkout'):L('addon_full','Half price if you choose two tags');
      addon.classList.toggle('is-on',st.addon); addon.classList.toggle('is-half',half);
      const chk=$('#addonChk'); if(chk) chk.checked=st.addon;
    }
    if(ONTAG){
      let total=v.price;
      if(st.addon&&CAL){ const c=calV(st.afor||PET_OF(st.collar)); total+=st.pack>1?Math.round(c.price/2):c.price; }
      countTo($('#addPrice'),total);
    }
    countTo($('#barPrice'),v.price);
    const bb=$('#barBundle'); if(bb) bb.textContent=packLabel(st.pack)+' · '+COLLAR_LABEL[st.collar];
    if(ONTAG) galToPet(PET_OF(st.collar));
    renderQuick();
  }
  function syncCal(){
    if(!CAL) return;
    $$('[data-calfor]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.calfor===st.calFor)));
    $$('.seg-x').forEach(s=>{ s.dataset.mode=st.calFor; });
    $$('[data-cal-for]').forEach(s=>{ s.dataset.calFor=st.calFor; });
    fillPrices();
    if(ONCAL){ countTo($('#addPrice'),calV(st.calFor).price); galToPet(st.calFor); }
  }
  document.addEventListener('change',e=>{
    const t=e.target; if(!t) return;
    if(t.name==='pack'){ st.pack=Number(t.value); syncTag(); buzz(6); }
    else if(t.name==='collar'){ st.collar=t.value; st.afor=null; syncTag(); buzz(6); }
    else if(t.id==='addonChk'){ st.addon=t.checked; syncTag(); buzz(6); }
  });

  /* estimated delivery: 7 to 12 working days from today */
  const addWD=(d,n)=>{ const x=new Date(d); let k=0; while(k<n){ x.setDate(x.getDate()+1); const w=x.getDay(); if(w!==0&&w!==6) k++; } return x; };
  const subWD=(d,n)=>{ const x=new Date(d); let k=0; while(k<n){ x.setDate(x.getDate()-1); const w=x.getDay(); if(w!==0&&w!==6) k++; } return x; };
  let DF=null, DFL=null; try{ DF=new Intl.DateTimeFormat(INTL==='en-IE'?'en-GB':INTL,{weekday:'short',day:'numeric',month:'short'}); DFL=new Intl.DateTimeFormat(INTL==='en-IE'?'en-GB':INTL,{weekday:'long',day:'numeric',month:'long'}); }catch(e){}
  const now=new Date();
  const ETA=DF?`${DF.format(addWD(now,7))} – ${DF.format(addWD(now,12))}`:'';
  if(ETA){
    $$('.js-eta').forEach(el=>{ el.textContent=ETA; });
    $$('.js-eta-short').forEach(el=>{ el.textContent=L('eta_short','Estimated delivery {d}',{d:ETA}); });
  }
  /* advent: days to the first door, and the last day to order for delivery before 1 December */
  (function(){
    const y=now.getMonth()===0&&now.getDate()<7?now.getFullYear()-1:now.getFullYear();
    const d1=new Date(y,11,1), d24=new Date(y,11,24);
    const today=new Date(now.getFullYear(),now.getMonth(),now.getDate());
    const days=Math.round((d1-today)/864e5);
    const nEl=$$('.js-adv-n'), uEl=$$('.js-adv-unit'), tEl=$$('.js-adv-txt');
    if(days>0){
      nEl.forEach(el=>{ el.dataset.to=days; el.textContent=String(days); });
      uEl.forEach(el=>{ el.textContent=days===1?L('day','day'):L('days','days'); });
      tEl.forEach(el=>{ el.textContent=L('adv_until','until the first door opens'); });
    } else if(today<=d24){
      const n=today.getDate();
      nEl.forEach(el=>{ el.dataset.to=n; el.textContent=String(n); });
      uEl.forEach(el=>{ el.textContent=''; });
      tEl.forEach(el=>{ el.textContent=L('adv_today','Today they open door {n}',{n}); });
    } else $$('[data-advent]').forEach(el=>{ el.hidden=true; });
    const last=subWD(d1,12);
    let msg='';
    if(DFL&&today<=last) msg=L('adv_by','Order by {d} to have it before 1 December.',{d:DFL.format(last)});
    else if(ETA&&today<d24) msg=L('adv_late','Ordered today, it arrives {d}. The doors can be opened in any order.',{d:ETA});
    if(msg) $$('.js-adv-by').forEach(el=>{ el.textContent=msg; });
  })();

  /* ---------- cart ---------- */
  let CART={items:[],item_count:0,total_price:0};
  function mockTotals(){
    const tagN=CART.items.filter(l=>VMAP[l.variant_id]&&VMAP[l.variant_id].p===TAG).reduce((a,l)=>a+VMAP[l.variant_id].v.pack*l.quantity,0);
    let disc=tagN>=2;
    CART.items.forEach(l=>{
      l.original_line_price=l.price*l.quantity; l.final_line_price=l.original_line_price;
      if(disc&&VMAP[l.variant_id]&&VMAP[l.variant_id].p===CAL){ l.final_line_price-=Math.round(l.price/2); disc=false; }
    });
    CART.item_count=CART.items.reduce((a,l)=>a+l.quantity,0);
    CART.total_price=CART.items.reduce((a,l)=>a+l.final_line_price,0);
  }
  function mock(path,body){
    if(path==='cart/add.js'){
      (body.items||[]).forEach(it=>{
        const x=VMAP[Number(it.id)]; if(!x) return;
        const l=CART.items.find(y=>y.variant_id===x.v.id);
        if(l) l.quantity+=it.quantity||1;
        else CART.items.push({key:'p'+x.v.id,variant_id:x.v.id,product_title:x.p.title,variant_title:x.v.t,quantity:it.quantity||1,price:x.v.price,image:x.p.img||null,url:x.p.url});
      });
    }
    if(path==='cart/change.js'){
      const l=CART.items.find(x=>x.key===body.id); if(l) l.quantity=body.quantity;
      CART.items=CART.items.filter(x=>x.quantity>0);
    }
    mockTotals();
    return Promise.resolve(JSON.parse(JSON.stringify(CART)));
  }
  async function api(path,body){
    if(!LIVE) return mock(path,body);
    const r=await fetch(ROOT+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json',Accept:'application/json'},body:body?JSON.stringify(body):undefined});
    if(!r.ok) throw new Error(path);
    return r.json();
  }
  async function refresh(){ try{ CART=await api('cart.js'); renderCart(); }catch(e){} }
  async function addItems(items,btn,img){
    items=items.filter(it=>it&&it.id); if(!items.length) return false;
    if(btn) btn.disabled=true;
    try{ await api('cart/add.js',{items:items.map(it=>({id:Number(it.id),quantity:it.quantity||1}))}); CART=await api('cart.js'); buzz(14); showHeader(); await fly(btn,img); renderCart(); bump(); return true; }
    catch(e){ toast(L('add_err','Couldn’t add it. Try again.')); return false; }
    finally{ if(btn) btn.disabled=false; }
  }
  async function change(key,q){ try{ CART=await api('cart/change.js',{id:key,quantity:Math.max(0,q)}); renderCart(); }catch(e){} }

  function cartInfo(c){
    const tagLines=c.items.filter(l=>VMAP[l.variant_id]&&VMAP[l.variant_id].p===TAG);
    const calLines=c.items.filter(l=>VMAP[l.variant_id]&&VMAP[l.variant_id].p===CAL);
    const tags=tagLines.reduce((a,l)=>a+VMAP[l.variant_id].v.pack*l.quantity,0);
    return {tagLines,calLines,tags};
  }
  function offerFor(c){
    if(!TAG) return null;
    const {tagLines,calLines,tags}=cartInfo(c);
    if(tags===1&&tagLines.length===1&&tagLines[0].quantity===1){
      const from=VMAP[tagLines[0].variant_id].v, to=tagV(2,from.collar);
      if(to&&to!==from) return {kind:'two',line:tagLines[0],from,to};
    }
    if(tags>=2&&!calLines.length&&CAL){ const pet=PET_OF(VMAP[tagLines[0].variant_id].v.collar); return {kind:'cal',to:calV(pet)}; }
    if(!tags&&calLines.length) return {kind:'tag',to:tagV(1,VMAP[calLines[0].variant_id].v.pet==='cat'?'C':'DM')};
    return null;
  }
  async function takeOffer(o,btn){
    if(btn) btn.disabled=true;
    try{
      if(o.kind==='two'){ await api('cart/change.js',{id:o.line.key,quantity:0}); st.pack=2; st.collar=o.to.collar; }
      await api('cart/add.js',{items:[{id:o.to.id,quantity:1}]});
      CART=await api('cart.js'); syncTag(); renderCart(); bump(); buzz(14);
      toast(o.kind==='two'?L('switched','Switched to {t}.',{t:packLabel(2)}):L('added','Added to your cart.'));
    }catch(e){ toast(L('switch_err','Couldn’t change it. Try again.')); if(btn) btn.disabled=false; }
  }
  let OFFER=null;
  function lineImg(it){ const x=VMAP[it.variant_id]; return it.image||(x&&(x.v.img||x.p.img))||''; }
  function renderCart(){
    const c=CART, cnt=$('#cartCount'); if(cnt){ cnt.textContent=c.item_count; cnt.classList.toggle('is-empty',!c.item_count); }
    const body=$('#drBody'), foot=$('#drFoot'); if(!body) return;
    if(!c.items.length){
      body.innerHTML=`<div class="empty"><p>${esc(L('cart_empty','Your cart is empty.'))}</p><a class="btn btn-solid btn-sm" href="${ONCAL?'#buy':HOMEURL+'#buy'}" id="emptyCta">${esc(L('cart_cta_cal','Choose your advent calendar'))}</a></div>`;
      foot.hidden=true; return;
    }
    foot.hidden=false;
    body.innerHTML=c.items.map((it,ix)=>{
      const src=lineImg(it), img=src?`<img src="${esc(src)}" alt="">`:'';
      const orig=it.original_line_price||it.price*it.quantity, fin=it.final_line_price;
      const x=VMAP[it.variant_id]; let sub=it.variant_title||'';
      if(x&&x.p===TAG) sub=packLabel(x.v.pack)+' · '+COLLAR_LABEL[x.v.collar];
      else if(x&&x.p===CAL) sub=x.v.pet==='cat'?L('for_cat','For cats'):L('for_dog','For dogs');
      const deal=orig>fin?`<small class="l-deal">${esc(L('deal','Christmas offer: half price'))}</small>`:'';
      return `<div class="line" style="--i:${ix}"><div class="line-th">${img}</div><div><strong>${esc(it.product_title)}</strong><small>${esc(sub)}</small>${deal}<div class="qty"><button type="button" data-chg="${esc(it.key)}" data-q="${it.quantity-1}" aria-label="${esc(L('less','Remove one'))}">−</button><span>${it.quantity}</span><button type="button" data-chg="${esc(it.key)}" data-q="${it.quantity+1}" aria-label="${esc(L('more','Add one'))}">+</button></div></div><div class="l-price">${money(fin)}<button type="button" data-chg="${esc(it.key)}" data-q="0">${esc(L('remove','Remove'))}</button></div></div>`;
    }).join('');
    $('#subTot').textContent=money(c.total_price);
    $('#shipTot').textContent=SHIP?money(SHIP):L('calc','Calculated at checkout');
    const sm=$('#shipMsg'); sm.textContent=L('ship_tracked','Every order ships tracked. We email you the link.'); sm.classList.add('ok');
    const up=$('#upsell'); OFFER=offerFor(c);
    if(up){
      if(!OFFER){ up.hidden=true; up.innerHTML=''; }
      else{
        const o=OFFER; let h='', s='', b='', pic='';
        if(o.kind==='two'){ h=L('up_two','Make it two tags'); s=L('up_two_s','{p} more, and the advent calendar is half price',{p:money(o.to.price-o.from.price)}); b=L('up_btn','Switch'); pic=dots(2); }
        else if(o.kind==='cal'){ h=L('up_cal','Add the advent calendar'); s=L('up_cal_s','Only {p} with your two tags',{p:money(Math.round(o.to.price/2))}); b=L('up_add','Add'); pic=CAL.img?`<img class="up-img" src="${esc(CAL.img)}" alt="">`:''; }
        else { h=L('up_tag','Add a HooPet Tag'); s=L('up_tag_s','{p}, fitted to its collar',{p:money(o.to.price)}); b=L('up_add','Add'); pic=dots(1); }
        up.innerHTML=`<span class="up-pic">${pic}</span><div><strong>${esc(h)}</strong><span>${esc(s)}</span></div><button type="button" class="btn btn-solid" id="upBtn">${esc(b)}</button>`;
        up.hidden=false;
      }
    }
  }

  function bump(){ const c=$('#cartCount'); if(!c) return; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
  function fly(from,img){
    const src=img||(TAG&&TAG.img)||(($('.gal-img')||{}).src); const to=$('#cartBtn');
    if(REDUCE||!from||!src||!to||!Element.prototype.animate) return Promise.resolve();
    const a=from.getBoundingClientRect(), b=to.getBoundingClientRect();
    if(!a.width||!b.width) return Promise.resolve();
    const box=document.createElement('div'); box.className='fly';
    const im=document.createElement('img'); im.src=src; im.alt=''; box.appendChild(im);
    box.style.left=(a.left+a.width/2-38)+'px'; box.style.top=(a.top+a.height/2-38)+'px';
    document.body.appendChild(box);
    const dx=b.left+b.width/2-(a.left+a.width/2), dy=b.top+b.height/2-(a.top+a.height/2);
    const an=box.animate([{transform:'translate(0,0) scale(.6)'},{transform:'translate(0,-24px) scale(1)',offset:.18},{transform:`translate(${dx*.55}px,${dy*.55-90}px) scale(.8)`,offset:.6},{transform:`translate(${dx}px,${dy}px) scale(.22)`}],{duration:760,easing:'cubic-bezier(.45,0,.25,1)'});
    return an.finished.catch(()=>{}).then(()=>box.remove());
  }

  /* cart drawer / bottom sheet */
  const drawer=$('#drawer'), scrim=$('#scrim');
  let lastFocus=null;
  function openCart(){ if(!drawer) return; closeAllMenus(); lastFocus=document.activeElement; scrim.hidden=false; drawer.style.setProperty('--drag','0px'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); lock(true); setTimeout(()=>{const b=$('#closeCart'); if(b) b.focus({preventScroll:true});},60); }
  function closeCart(){ if(!drawer) return; scrim.hidden=true; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); lock(anyOpen()); if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true}); }
  function sheetDrag(el,handles,onClose,cssVar,onMove,mq){
    let y0=null, dy=0, t0=0;
    handles.forEach(h=>{
      if(!h) return;
      h.addEventListener('pointerdown',e=>{ if(!mq.matches||(el.classList.contains('pop')&&!el.classList.contains('is-sheet'))||e.target.closest('button,input,a')) return; y0=e.clientY; dy=0; t0=performance.now(); el.classList.add('is-drag'); try{h.setPointerCapture(e.pointerId);}catch(_){} });
      h.addEventListener('pointermove',e=>{ if(y0==null) return; const raw=e.clientY-y0; dy=raw>0?raw:-Math.sqrt(-raw)*2; el.style.setProperty(cssVar,dy+'px'); if(onMove) onMove(dy); });
      const up=()=>{ if(y0==null) return; const v=dy/Math.max(1,performance.now()-t0); y0=null; el.classList.remove('is-drag'); if(onMove) onMove(0); if(dy>110||v>.55){ onClose(); buzz(8); } else el.style.setProperty(cssVar,'0px'); };
      h.addEventListener('pointerup',up); h.addEventListener('pointercancel',up);
    });
  }
  if(drawer) sheetDrag(drawer,[$('#drGrab'),$('#drHead')],closeCart,'--drag',dy=>{ scrim.style.opacity=dy?String(clamp(1-dy/420,0,1)):''; },MQ_SHEET);
  let tt; function toast(m){ const el=$('#toast'); if(!el) return; el.textContent=m; el.classList.add('show'); clearTimeout(tt); tt=setTimeout(()=>el.classList.remove('show'),2600); }

  /* gallery: swipe track, bars, thumbs, full-screen viewer */
  const track=$('#galTrack');
  const slides=track?Array.from(track.querySelectorAll('.gal-slide')):[];
  const bars=$('.gal-bars');
  if(bars) bars.innerHTML=slides.map(()=>'<i></i>').join('');
  let gi=0;
  function setGi(i){
    gi=i;
    if(bars) Array.from(bars.children).forEach((b,k)=>b.classList.toggle('on',k<=i));
    $$('.thumb').forEach(t=>{ const on=Number(t.dataset.i)===i; t.classList.toggle('is-on',on); t.setAttribute('aria-pressed',String(on)); });
  }
  if(track){
    let raf=0;
    track.addEventListener('scroll',()=>{ cancelAnimationFrame(raf); raf=requestAnimationFrame(()=>{ const i=Math.round(track.scrollLeft/Math.max(1,track.clientWidth)); if(i!==gi){ setGi(i); buzz(4); } }); },{passive:true});
    track.addEventListener('click',e=>{ const s=e.target.closest('.gal-slide'); if(s) openLb(slides.indexOf(s)); });
    track.addEventListener('keydown',e=>{ if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ e.preventDefault(); goGal(gi+(e.key==='ArrowRight'?1:-1)); } if(e.key==='Enter') openLb(gi); });
    setGi(0);
  }
  function goGal(i,instant){ if(!track) return; i=clamp(i,0,slides.length-1); track.scrollTo({left:i*track.clientWidth,behavior:REDUCE||instant?'auto':'smooth'}); setGi(i); }
  let lastPet=null;
  function galToPet(pet){
    if(!track||!slides.length||pet===lastPet) return;
    const first=lastPet===null; lastPet=pet;
    const cur=slides[gi]; if(cur&&cur.dataset.pet===pet&&!first) return;
    const i=slides.findIndex(s=>s.dataset.pet===pet);
    if(i>-1&&(i!==gi)) goGal(i,first);
  }
  const zb=$('#galZoom'); if(zb) zb.addEventListener('click',()=>openLb(gi));

  const lb=$('#lb'), lbTrack=$('#lbTrack');
  let lbBuilt=false, lbi=0;
  function lbCount(){ const c=$('#lbCount'); if(c) c.textContent=`${lbi+1} / ${slides.length}`; }
  function buildLb(){
    lbTrack.innerHTML=slides.map(s=>{ const im=s.querySelector('img'); const src=im?(im.currentSrc||im.src):''; return `<div class="lb-slide"><img src="${src}" alt="${esc(im?im.alt:'')}" draggable="false"></div>`; }).join('');
    lbTrack.addEventListener('scroll',()=>{ const i=Math.round(lbTrack.scrollLeft/Math.max(1,lbTrack.clientWidth)); if(i!==lbi){ lbi=i; lbCount(); } },{passive:true});
    lbGestures(); lbBuilt=true;
  }
  function openLb(i){
    if(!lb||!slides.length) return;
    if(!lbBuilt) buildLb();
    lb.hidden=false; lb.classList.add('is-open'); lock(true); lbi=clamp(i,0,slides.length-1); lbCount();
    requestAnimationFrame(()=>{ lbTrack.scrollLeft=lbi*lbTrack.clientWidth; });
    const c=$('#lbClose'); if(c) c.focus({preventScroll:true});
  }
  function closeLb(){
    if(!lb||lb.hidden) return;
    unzoom(); lb.hidden=true; lb.classList.remove('is-open'); lbTrack.style.transform=''; lb.style.backgroundColor='';
    lock(anyOpen());
    if(track&&lbi!==gi) { track.scrollLeft=lbi*track.clientWidth; setGi(lbi); }
    if(track) track.focus({preventScroll:true});
  }
  let zoomed=null, zs=2.4, ztx=0, zty=0;
  function applyZoom(img){ img.style.transform=`translate(${ztx}px,${zty}px) scale(${zs})`; }
  function zoomAt(slide,x,y){
    const img=slide.querySelector('img'); if(!img) return;
    const r=img.getBoundingClientRect();
    img.style.transformOrigin=`${clamp(x-r.left,0,r.width)}px ${clamp(y-r.top,0,r.height)}px`;
    ztx=0; zty=0; applyZoom(img); slide.classList.add('zoomed'); lb.classList.add('is-zoomed'); zoomed=slide;
  }
  function unzoom(){ if(!zoomed) return; const img=zoomed.querySelector('img'); if(img) img.style.transform=''; zoomed.classList.remove('zoomed','panning'); lb.classList.remove('is-zoomed'); zoomed=null; }
  function lbGestures(){
    let sx=0, sy=0, mode=null, lastTap=0, lastX=0, lastY=0, px=0, py=0;
    lbTrack.addEventListener('pointerdown',e=>{ sx=px=e.clientX; sy=py=e.clientY; mode=zoomed?'pan':null; if(zoomed) zoomed.classList.add('panning'); });
    lbTrack.addEventListener('pointermove',e=>{
      if(e.buttons===0&&e.pointerType==='mouse') return;
      const dx=e.clientX-sx, dy=e.clientY-sy;
      if(mode==='pan'&&zoomed){ ztx+=e.clientX-px; zty+=e.clientY-py; px=e.clientX; py=e.clientY; applyZoom(zoomed.querySelector('img')); return; }
      if(!mode&&Math.abs(dy)>10&&Math.abs(dy)>Math.abs(dx)*1.2&&dy>0){ mode='down'; try{lbTrack.setPointerCapture(e.pointerId);}catch(_){} }
      if(mode==='down'){ const d=Math.max(0,dy); lbTrack.style.transform=`translateY(${d}px) scale(${1-Math.min(.12,d/2400)})`; lb.style.backgroundColor=`rgba(251,248,242,${clamp(1-d/500,0,1)})`; }
    });
    const end=e=>{
      if(zoomed) zoomed.classList.remove('panning');
      if(mode==='down'){ const dy=e.clientY-sy; lbTrack.style.transition='transform .35s cubic-bezier(.32,.72,0,1)'; if(dy>110){ buzz(8); closeLb(); } else { lbTrack.style.transform=''; lb.style.backgroundColor=''; } setTimeout(()=>{ lbTrack.style.transition=''; },360); mode=null; return; }
      const moved=Math.hypot(e.clientX-sx,e.clientY-sy);
      mode=null;
      if(moved>12) return;
      const now=performance.now();
      if(now-lastTap<300&&Math.hypot(e.clientX-lastX,e.clientY-lastY)<36){
        lastTap=0;
        const sl=e.target.closest('.lb-slide');
        if(zoomed) unzoom(); else if(sl){ zoomAt(sl,e.clientX,e.clientY); buzz(6); }
      } else { lastTap=now; lastX=e.clientX; lastY=e.clientY; }
    };
    lbTrack.addEventListener('pointerup',end); lbTrack.addEventListener('pointercancel',()=>{ mode=null; lbTrack.style.transform=''; lb.style.backgroundColor=''; });
  }
  const lbc=$('#lbClose'); if(lbc) lbc.addEventListener('click',closeLb);

  /* iPhone / Android steps */
  const steps=$('#steps');
  $$('.how .seg-btn').forEach(b=>b.addEventListener('click',()=>{
    const m=b.dataset.mode; if(!steps||steps.dataset.mode===m) return;
    const seg=b.closest('.seg');
    const apply=()=>{ steps.dataset.mode=m; if(seg) seg.dataset.mode=m; $$('.how .seg-btn').forEach(x=>x.setAttribute('aria-pressed',String(x===b))); $$('.how-cta').forEach(x=>{ x.dataset.mode=m; }); };
    if(document.startViewTransition&&!REDUCE) document.startViewTransition(apply); else apply();
    buzz(6);
  }));
  (function(){ const ua=navigator.userAgent||''; if(/Android/i.test(ua)){ const b=$('.how .seg-btn[data-mode="android"]'); if(b&&steps){ steps.dataset.mode='android'; const seg=b.closest('.seg'); if(seg) seg.dataset.mode='android'; $$('.how .seg-btn').forEach(x=>x.setAttribute('aria-pressed',String(x===b))); $$('.how-cta').forEach(x=>{ x.dataset.mode='android'; }); } } })();

  /* dogs / cats switches (shop tiles and catalog) */
  function setPet(sw,pet){
    const tiles=$('#tiles'); if(!tiles) return;
    const apply=()=>{
      tiles.dataset.pet=pet; let n=0;
      tiles.querySelectorAll('.ptile').forEach(t=>{ const f=(t.dataset.for||'').split(/\s+/); const show=pet==='all'||f.includes(pet); t.hidden=!show; if(show) n++; });
      $$('.js-cat-n').forEach(el=>{ el.textContent=String(n); });
      sw.querySelectorAll('.pet-btn').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.pet===pet)));
      movePill(sw);
    };
    if(document.startViewTransition&&!REDUCE) document.startViewTransition(apply); else apply();
  }
  function movePill(sw){ const on=sw.querySelector('.pet-btn[aria-pressed="true"]'), pill=sw.querySelector('.pet-pill'); if(!on||!pill) return; pill.style.width=on.offsetWidth+'px'; pill.style.transform=`translateX(${on.offsetLeft-4}px)`; }
  $$('.pet-switch').forEach(sw=>{ sw.addEventListener('click',e=>{ const b=e.target.closest('.pet-btn'); if(b&&b.getAttribute('aria-pressed')!=='true'){ setPet(sw,b.dataset.pet); buzz(5); } }); movePill(sw); });
  window.addEventListener('resize',()=>$$('.pet-switch').forEach(movePill));
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(()=>$$('.pet-switch').forEach(movePill));
  const tilesN=$('#tiles'); if(tilesN) $$('.js-cat-n').forEach(el=>{ el.textContent=String(tilesN.querySelectorAll('.ptile').length); });

  /* statement lights up word by word as it scrolls past */
  const lit=$('[data-lit]'); let litWords=[], litN=-1;
  if(lit&&!REDUCE){
    const words=lit.textContent.trim().split(/\s+/);
    lit.innerHTML=words.map(w=>`<span class="wd">${esc(w)}</span>`).join(' ');
    litWords=Array.from(lit.children);
  }
  function updLit(){
    if(!litWords.length) return;
    const r=lit.getBoundingClientRect(), vh=window.innerHeight;
    const p=clamp((vh*.86-r.top)/(r.height+vh*.36),0,1), n=Math.round(p*litWords.length);
    if(n!==litN){ litWords.forEach((s,i)=>s.classList.toggle('on',i<n)); litN=n; }
  }

  /* announcement: one message at a time on phones */
  const ns=$$('.notice-set span'); let ni=0;
  if(ns.length>1&&!REDUCE){
    const mqN=window.matchMedia('(max-width: 1100px)');
    setInterval(()=>{
      if(!mqN.matches||document.hidden) return;
      const cur=ns[ni]; ni=(ni+1)%ns.length; const nx=ns[ni];
      cur.classList.remove('on'); cur.classList.add('out'); nx.classList.remove('out'); nx.classList.add('on');
      setTimeout(()=>cur.classList.remove('out'),650);
    },3600);
  }

  /* detail explorer: plays through on its own until someone taps */
  const ex=$('[data-explorer]');
  if(ex){
    const btns=Array.from(ex.querySelectorAll('.ex-btn')), cards=Array.from(ex.querySelectorAll('.ex-card')), list=ex.querySelector('.ex-list');
    const DUR=5200; let ei=0, auto=!REDUCE, exT=null, exVis=false;
    ex.classList.add('is-live'); if(auto) ex.classList.add('is-auto'); ex.style.setProperty('--ex-dur',DUR+'ms');
    const restartBar=()=>{ const pr=btns[ei]&&btns[ei].querySelector('.ex-prog'); if(pr){ pr.style.animation='none'; void pr.offsetWidth; pr.style.animation=''; } };
    const schedule=()=>{ clearTimeout(exT); if(auto&&exVis){ restartBar(); exT=setTimeout(()=>show(ei+1,false),DUR); } };
    function show(i,user){
      ei=(i+btns.length)%btns.length;
      btns.forEach((b,k)=>{ b.setAttribute('aria-selected',String(k===ei)); b.tabIndex=k===ei?0:-1; });
      cards.forEach((c,k)=>{ c.classList.toggle('is-off',k!==ei); c.setAttribute('aria-hidden',String(k!==ei)); });
      ex.dataset.on=btns[ei].id||'';
      if(user){ auto=false; ex.classList.remove('is-auto'); clearTimeout(exT); buzz(5); }
      if(list&&list.scrollWidth>list.clientWidth+4){ const li=btns[ei].parentElement; list.scrollTo({left:Math.max(0,li.offsetLeft-24),behavior:REDUCE?'auto':'smooth'}); }
      schedule();
    }
    btns.forEach((b,k)=>b.addEventListener('click',()=>show(k,true)));
    if(list) list.addEventListener('keydown',e=>{
      const nx=(e.key==='ArrowDown'||e.key==='ArrowRight')?1:(e.key==='ArrowUp'||e.key==='ArrowLeft')?-1:0;
      if(nx){ e.preventDefault(); show(ei+nx,true); btns[ei].focus(); }
    });
    if('IntersectionObserver' in window) new IntersectionObserver(es=>{ exVis=es[0].isIntersecting; ex.classList.toggle('is-paused',!exVis); schedule(); },{threshold:.35}).observe(ex);
    show(0,false);
  }

  /* question filters */
  $$('.chip').forEach(c=>c.addEventListener('click',()=>{
    const f=c.dataset.f; $$('.chip').forEach(x=>x.setAttribute('aria-pressed',String(x===c)));
    const apply=()=>$$('.faq-list details').forEach(d=>d.classList.toggle('is-filtered',f!=='all'&&d.dataset.cat!==f));
    if(document.startViewTransition&&!REDUCE) document.startViewTransition(apply); else apply();
    buzz(5);
  }));

  /* one-tap choices in the closing section */
  const quick=$('#quick');
  function renderQuick(){
    if(!quick||!TAG) return;
    const t1=tagV(1,st.collar), t2=tagV(2,st.collar), c=CAL&&calV(PET_OF(st.collar));
    const tiles=[
      {id:t1.id,title:packLabel(1),price:t1.price,sub:COLLAR_LABEL[st.collar],pic:dots(1)},
      {id:t2.id,title:packLabel(2),price:t2.price,sub:L('per_tag','{p} per tag',{p:money(Math.round(t2.price/2))}),pic:dots(2),best:true,tag:CAL?L('pack2_tag','Calendar half price'):''},
    ];
    if(c) tiles.push({id:c.id,title:CAL.title,price:c.price,sub:L('with_two','{p} with two tags',{p:money(Math.round(c.price/2))}),pic:'<span class="q-star" aria-hidden="true">★</span>',img:CAL.img});
    quick.innerHTML=tiles.map(t=>`<button type="button" class="q-tile${t.best?' is-best':''}" data-v="${t.id}">${t.pic}<span class="q-title">${esc(t.title)}</span>${t.tag?`<span class="q-tag">${esc(t.tag)}</span>`:''}<span class="q-price">${money(t.price)}</span><span class="q-per">${esc(t.sub)}</span><span class="q-add">${esc(L('add','Add to cart'))}</span></button>`).join('');
  }
  if(quick) quick.addEventListener('click',async e=>{ const t=e.target.closest('.q-tile'); if(!t) return; const id=Number(t.dataset.v), x=VMAP[id]; if(x&&x.p===TAG){ st.pack=x.v.pack; syncTag(); } if(await addItems([{id}],t,x&&x.p.img)) openCart(); });

  /* ---------- header: Shop menu, mobile menu, country and language ---------- */
  const site=$('#site'), megaBtn=$('#megaBtn'), mega=$('#mega');
  let megaT=0;
  function setMega(o){ if(!site||!megaBtn) return; if(o&&!MQ_DESK.matches) o=false; site.classList.toggle('mega-open',o); megaBtn.setAttribute('aria-expanded',String(o)); }
  if(megaBtn&&mega){
    megaBtn.addEventListener('click',()=>{ clearTimeout(megaT); setMega(!site.classList.contains('mega-open')); });
    megaBtn.addEventListener('pointerenter',e=>{ if(e.pointerType!=='mouse') return; clearTimeout(megaT); megaT=setTimeout(()=>setMega(true),80); });
    [megaBtn,mega].forEach(el=>el.addEventListener('pointerleave',e=>{ if(e.pointerType!=='mouse') return; clearTimeout(megaT); megaT=setTimeout(()=>setMega(false),240); }));
    mega.addEventListener('pointerenter',()=>clearTimeout(megaT));
    mega.addEventListener('click',e=>{ if(e.target.closest('a')) setMega(false); });
    document.addEventListener('pointerdown',e=>{ if(site.classList.contains('mega-open')&&!e.target.closest('#mega,#megaBtn')) setMega(false); });
    MQ_DESK.addEventListener&&MQ_DESK.addEventListener('change',()=>setMega(false));
  }

  const mnav=$('#mnav'), mb=$('#menuBtn'), panel=mnav&&mnav.querySelector('.mnav-panel');
  let navT=0;
  function openNav(){ if(!mnav) return; clearTimeout(navT); lastFocus=document.activeElement; mnav.classList.remove('is-out'); mnav.hidden=false; if(panel) panel.style.transform=''; lock(true); if(mb) mb.setAttribute('aria-expanded','true'); buzz(6); setTimeout(()=>{ const c=$('#mnavClose'); if(c) c.focus({preventScroll:true}); },60); }
  function closeNav(now){
    if(!mnav||mnav.hidden) return; if(mb) mb.setAttribute('aria-expanded','false');
    const done=()=>{ mnav.hidden=true; mnav.classList.remove('is-out'); if(panel) panel.style.transform=''; lock(anyOpen()); };
    if(now||REDUCE){ done(); return; }
    mnav.classList.add('is-out'); navT=setTimeout(done,300);
  }
  /* a link to the page we are on (with ?collar=) just changes the choice and scrolls */
  function samePageLink(a){
    if(!a||!a.href) return null;
    let u; try{ u=new URL(a.href,location.href); }catch(e){ return null; }
    if(u.origin!==location.origin||u.pathname!==location.pathname) return null;
    return u;
  }
  function applyLink(u){
    const c=(u.searchParams.get('collar')||'').toLowerCase();
    if(c==='cat') st.collar='C'; else if(c==='dog'&&st.collar==='C') st.collar='DM';
    if(c){ st.afor=null; syncTag(); }
    const t=u.hash&&document.querySelector(u.hash);
    if(t){ t.scrollIntoView({behavior:REDUCE?'auto':'smooth'}); history.replaceState(null,'',u.hash); }
    return !!t;
  }
  if(mnav&&mb){
    mb.addEventListener('click',openNav);
    const mc=$('#mnavClose'); if(mc) mc.addEventListener('click',()=>closeNav());
    mnav.addEventListener('click',e=>{
      if(e.target===mnav){ closeNav(); return; }
      const a=e.target.closest('a'); if(!a) return;
      const u=samePageLink(a);
      if(u&&(u.hash||u.search)){ e.preventDefault(); closeNav(true); setTimeout(()=>applyLink(u),30); return; }
      if(a.getAttribute('href')&&a.getAttribute('href').charAt(0)!=='#') closeNav();
    });
    if(panel){
      let x0=null, y0=0, dx=0, horiz=null;
      panel.addEventListener('pointerdown',e=>{ if(e.pointerType==='mouse') return; x0=e.clientX; y0=e.clientY; dx=0; horiz=null; });
      panel.addEventListener('pointermove',e=>{ if(x0==null) return; const ddx=e.clientX-x0, ddy=e.clientY-y0; if(horiz===null&&(Math.abs(ddx)>8||Math.abs(ddy)>8)) horiz=Math.abs(ddx)>Math.abs(ddy); if(!horiz) return; dx=Math.min(0,ddx); panel.style.transition='none'; panel.style.transform=`translateX(${dx}px)`; });
      const end=()=>{ if(x0==null) return; x0=null; panel.style.transition=''; if(horiz&&dx<-90){ closeNav(); } else panel.style.transform=''; };
      panel.addEventListener('pointerup',end); panel.addEventListener('pointercancel',end);
    }
  }

  const pscrim=$('#popScrim'); let popTrig=null;
  function placePop(p,t){
    const sheet=!MQ_DESK.matches||!t||!!t.closest('.mnav')||p.classList.contains('pop-guide');
    p.classList.toggle('is-sheet',sheet&&!(MQ_DESK.matches&&p.classList.contains('pop-guide')));
    if(p.classList.contains('pop-guide')&&MQ_DESK.matches){ p.classList.add('is-center'); p.style.left=''; p.style.top=''; return; }
    p.classList.remove('is-center');
    if(p.classList.contains('is-sheet')){ p.style.left=''; p.style.top=''; p.style.setProperty('--pdrag','0px'); return; }
    const r=t.getBoundingClientRect(), w=p.offsetWidth, h=p.offsetHeight;
    const left=clamp(r.right-w,12,window.innerWidth-w-12);
    let top=r.bottom+10; if(top+h>window.innerHeight-12) top=Math.max(12,r.top-h-10);
    p.style.left=left+'px'; p.style.top=top+'px';
  }
  function openPop(id,trig){
    const p=document.getElementById(id); if(!p) return;
    if(popOpen) closePop(true);
    setMega(false); popOpen=p; popTrig=trig;
    p.hidden=false; placePop(p,trig);
    const dim=p.classList.contains('is-sheet')||p.classList.contains('is-center');
    if(pscrim){ pscrim.hidden=false; pscrim.classList.toggle('dim',dim); }
    if(trig) trig.setAttribute('aria-expanded','true');
    if(dim) lock(true);
    const list=p.querySelector('.pop-list'), cur=p.querySelector('.pop-opt[aria-current]');
    if(list&&cur) list.scrollTop=Math.max(0,list.scrollTop+cur.getBoundingClientRect().top-list.getBoundingClientRect().top-cur.offsetHeight-6);
    const s=p.querySelector('input[type=search]');
    if(s&&!p.classList.contains('is-sheet')) s.focus({preventScroll:true}); else (cur||p.querySelector('.pop-x')).focus({preventScroll:true});
    const g=p.querySelector('.guide-t'); if(g){ g.querySelectorAll('tr[data-c]').forEach(r=>r.classList.toggle('is-on',r.dataset.c===st.collar)); }
    buzz(5);
  }
  function closePop(silent){
    const p=popOpen; if(!p) return; popOpen=null;
    p.hidden=true; p.classList.remove('is-drag','is-center'); if(pscrim){ pscrim.hidden=true; pscrim.style.opacity=''; }
    if(popTrig){ popTrig.setAttribute('aria-expanded','false'); if(!silent) popTrig.focus({preventScroll:true}); }
    const s=p.querySelector('input[type=search]'); if(s&&s.value){ s.value=''; s.dispatchEvent(new Event('input')); }
    lock(anyOpen());
  }
  document.addEventListener('click',e=>{ const t=e.target.closest('[data-pop]'); if(t){ e.preventDefault(); const id=t.dataset.pop; if(popOpen&&popOpen.id===id) closePop(); else openPop(id,t); } });
  if(pscrim) pscrim.addEventListener('click',()=>closePop());
  $$('.pop').forEach(p=>{
    const x=p.querySelector('[data-close]'); if(x) x.addEventListener('click',()=>closePop());
    sheetDrag(p,[p.querySelector('.pop-grab'),p.querySelector('.pop-head')],()=>closePop(),'--pdrag',dy=>{ if(pscrim) pscrim.style.opacity=dy?String(clamp(1-dy/380,0,1)):''; },MQ_PHONE);
    p.addEventListener('keydown',e=>{
      if(e.key!=='ArrowDown'&&e.key!=='ArrowUp') return;
      const opts=Array.from(p.querySelectorAll('.pop-opt')).filter(o=>!o.closest('li').hidden); if(!opts.length) return;
      const i=opts.indexOf(document.activeElement); e.preventDefault();
      const n=i<0?(e.key==='ArrowDown'?0:opts.length-1):clamp(i+(e.key==='ArrowDown'?1:-1),0,opts.length-1);
      opts[n].focus();
    });
  });
  window.addEventListener('resize',()=>{ if(popOpen&&!popOpen.classList.contains('is-sheet')&&!popOpen.classList.contains('is-center')) closePop(true); });
  const norm=s=>String(s||'').normalize('NFD').replace(/[̀-ͯ]/g,'').toLowerCase().trim();
  const ps=$('#popSearch'), pl=$('#popCountryList'), pe=$('#popEmpty');
  if(ps&&pl){
    ps.addEventListener('input',()=>{ const q=norm(ps.value); let n=0; pl.querySelectorAll('li').forEach(li=>{ const b=li.querySelector('.pop-opt'); const ok=!q||norm(b.dataset.q||b.textContent).includes(q); li.hidden=!ok; if(ok) n++; }); if(pe) pe.hidden=n>0; });
    ps.addEventListener('keydown',e=>{ if(e.key==='Enter'){ const first=pl.querySelector('li:not([hidden]) .pop-opt'); if(first){ e.preventDefault(); first.click(); } } });
  }
  document.addEventListener('submit',e=>{
    const f=e.target;
    if(f.classList&&f.classList.contains('loc-form')&&!f.hasAttribute('data-preview')){ document.documentElement.classList.add('is-switching'); }
  });

  /* suggest the visitor's own language once */
  (function(){
    const box=$('#langHint'); if(!box) return;
    let seen=false; try{ seen=localStorage.getItem('hpLangHint')==='1'; }catch(e){}
    if(seen) return;
    const avail=String(cfg.dataset.langs||'').split(',').filter(Boolean);
    const want=String((navigator.languages&&navigator.languages[0])||navigator.language||'').slice(0,2).toLowerCase();
    const H={en:['This shop is also available in English.','English'],es:['Esta tienda también está en español.','Español'],nl:['Deze winkel is ook in het Nederlands.','Nederlands'],fr:['Cette boutique existe aussi en français.','Français'],de:['Diesen Shop gibt es auch auf Deutsch.','Deutsch']};
    if(!want||want===LANG||!avail.includes(want)||!H[want]) return;
    const msg=$('#langHintMsg'), yes=$('#langHintYes');
    msg.textContent=H[want][0]; msg.lang=want; yes.textContent=H[want][1]; yes.lang=want; yes.value=want;
    box.hidden=false;
    const done=()=>{ try{ localStorage.setItem('hpLangHint','1'); }catch(e){} };
    $('#langHintNo').addEventListener('click',()=>{ done(); box.classList.add('is-out'); setTimeout(()=>{ box.hidden=true; },REDUCE?0:300); });
    yes.addEventListener('click',done);
  })();

  /* Shopify's account button; plain link if it can't load */
  (function(){
    const a=$('#hpAccount'), link=$('.acct-link'); if(!a||!link) return;
    const check=()=>{ const ok=customElements.get('shopify-account')&&a.getBoundingClientRect().width>4; if(!ok){ a.remove(); link.hidden=false; } };
    const go=()=>setTimeout(check,2500);
    if(document.readyState==='complete') go(); else window.addEventListener('load',go);
  })();

  function closeAllMenus(){ setMega(false); closePop(true); closeNav(true); }

  /* big headlines shrink until their longest word fits (long Dutch and German words) */
  function fitHeads(){
    $$('.hero h1, .pg-h1, .buy-title').forEach(h=>{
      h.style.fontSize=''; let fs=parseFloat(getComputedStyle(h).fontSize), n=0;
      while(n<24&&h.scrollWidth>h.clientWidth+1){ fs*=.95; h.style.fontSize=fs+'px'; n++; }
    });
  }
  fitHeads(); if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fitHeads);
  let fitT=0; window.addEventListener('resize',()=>{ clearTimeout(fitT); fitT=setTimeout(fitHeads,150); });

  /* header hides on the way down (phones), comes back on the way up */
  function showHeader(){ if(site) site.classList.remove('is-hidden'); }
  let lastY=window.scrollY;
  function onScroll(){
    const y=window.scrollY, d=y-lastY; lastY=y;
    if(site&&MQ_PHONE.matches&&!REDUCE){
      if(y>140&&d>6&&!popOpen) site.classList.add('is-hidden');
      else if(d<-6||y<=140) site.classList.remove('is-hidden');
    }
    if(site) site.classList.toggle('is-scrolled',y>8);
    updLit();
  }
  let sRaf=0;
  window.addEventListener('scroll',()=>{ if(sRaf) return; sRaf=requestAnimationFrame(()=>{ sRaf=0; onScroll(); }); },{passive:true});

  /* clicks */
  function chipIn(scope,sel){ const b=scope&&scope.querySelector(sel+'[aria-pressed="true"]'); return b; }
  document.addEventListener('click',async e=>{
    const ch=e.target.closest('[data-chg]'); if(ch){ change(ch.dataset.chg,parseInt(ch.dataset.q,10)); return; }
    const th=e.target.closest('.thumb'); if(th){ goGal(Number(th.dataset.i)); return; }
    if(e.target.closest('#upBtn')&&OFFER){ takeOffer(OFFER,e.target.closest('#upBtn')); return; }
    if(e.target.closest('#emptyCta')){ closeCart(); return; }
    const cm=e.target.closest('.chip-mini');
    if(cm&&!cm.hasAttribute('data-afor')){ const g=cm.parentElement; g.querySelectorAll('.chip-mini').forEach(x=>x.setAttribute('aria-pressed',String(x===cm))); buzz(4); return; }
    const af=e.target.closest('[data-afor]'); if(af){ st.afor=af.dataset.afor; syncTag(); buzz(4); return; }
    const cf=e.target.closest('[data-calfor]'); if(cf){ if(st.calFor!==cf.dataset.calfor){ st.calFor=cf.dataset.calfor; syncCal(); buzz(5); } return; }
    const qa=e.target.closest('[data-qadd]');
    if(qa){
      const kind=qa.dataset.qadd, card=qa.closest('.ptile');
      if(kind==='tag'&&TAG){ const c=chipIn(card,'[data-qcollar]'), code=c?c.dataset.qcollar:st.collar, v=tagV(1,code); setMega(false); if(await addItems([{id:v.id}],qa,TAG.img)) openCart(); }
      if(kind==='cal'&&CAL){ const c=chipIn(card,'[data-qfor]'), pet=c?c.dataset.qfor:st.calFor, v=calV(pet); if(await addItems([{id:v.id}],qa,CAL.img)) openCart(); }
      return;
    }
    const pp=e.target.closest('[data-pick-pack]'); if(pp&&TAG){ st.pack=Number(pp.dataset.pickPack)||2; syncTag(); }
    const pk=e.target.closest('[data-pick-collar]'); if(pk&&TAG){ st.collar=pk.dataset.pickCollar==='cat'?'C':(st.collar==='C'?'DM':st.collar); st.afor=null; syncTag(); }
    const a=e.target.closest('a');
    if(a&&!e.defaultPrevented&&!e.metaKey&&!e.ctrlKey&&!a.closest('.mnav')){ const u=samePageLink(a); if(u&&u.search&&u.hash){ e.preventDefault(); setMega(false); applyLink(u); return; } }
    const cp=e.target.closest('[data-copy]'); if(cp){ const v=cp.dataset.copy; try{ await navigator.clipboard.writeText(v); }catch(_){ } toast(L('copied','Code copied: {c}',{c:v})); buzz(8); return; }
    const pv=e.target.closest('a[href^="#pv-"]'); if(pv){ e.preventDefault(); const k=pv.getAttribute('href'); toast(k==='#pv-account'?'Preview: in your store this opens sign-in with an email code, Shop or Google.':k==='#pv-discount'?'Preview: in your store this adds HOOPET10 to the cart.':'Preview: in your store this opens the legal page.'); }
  });
  const addBtn=$('#addBtn');
  if(addBtn) addBtn.addEventListener('click',async()=>{
    let items=[], img='';
    if(ONTAG&&TAG){ const v=tagV(st.pack,st.collar); items.push({id:v.id}); img=TAG.img; if(st.addon&&CAL) items.push({id:calV(st.afor||PET_OF(st.collar)).id}); }
    else if(ONCAL&&CAL){ items.push({id:calV(st.calFor).id}); img=CAL.img; }
    if(await addItems(items,addBtn,img)) openCart();
  });
  const barAdd=$('#barAdd'); if(barAdd) barAdd.addEventListener('click',async()=>{ if(!TAG) return; const v=tagV(st.pack,st.collar); if(await addItems([{id:v.id}],barAdd,TAG.img)) openCart(); });
  const cb=$('#cartBtn'); if(cb) cb.addEventListener('click',()=>{ refresh(); openCart(); });
  const cc=$('#closeCart'); if(cc) cc.addEventListener('click',closeCart);
  if(scrim) scrim.addEventListener('click',closeCart);
  document.addEventListener('keydown',e=>{
    if(lb&&!lb.hidden){
      if(e.key==='Escape') closeLb();
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ unzoom(); lbTrack.scrollTo({left:clamp(lbi+(e.key==='ArrowRight'?1:-1),0,slides.length-1)*lbTrack.clientWidth,behavior:'smooth'}); }
      return;
    }
    if(e.key!=='Escape') return;
    if(popOpen){ closePop(); return; }
    if(drawer&&drawer.classList.contains('open')){ closeCart(); return; }
    if(mnav&&!mnav.hidden){ closeNav(); if(mb) mb.focus(); return; }
    if(site&&site.classList.contains('mega-open')){ setMega(false); if(megaBtn) megaBtn.focus(); }
  });
  const co=$('#checkout'); if(co) co.addEventListener('click',()=>{ if(LIVE) window.location.href=ROOT+'checkout'; else toast('Preview: in your store this opens the Shopify checkout.'); });

  /* forms: newsletter code, contact, preview-only switches */
  const codeBox=$('#news .code-box'); if(codeBox&&/customer_posted/.test(location.search)) setTimeout(()=>{ $('#news').scrollIntoView({block:'center'}); },300);
  const cok=$('.cform-ok'); if(cok&&/contact_posted/.test(location.search)) setTimeout(()=>{ cok.scrollIntoView({block:'center'}); },200);
  document.addEventListener('submit',e=>{
    const f=e.target; if(!f.hasAttribute||!f.hasAttribute('data-preview')) return;
    e.preventDefault();
    const sub=e.submitter;
    if(f.id==='locLangForm'&&sub){ const l=sub.value, pg=(($('main')||{}).dataset||{}).pvPage||'index'; location.href=(l==='en'?'':l+'-')+pg+'.html'; return; }
    if(f.id==='locCountryForm'&&sub){ const n=sub.querySelector('.pop-name'); closePop(true); toast('Preview: in your store, prices and shipping switch to '+(n?n.textContent:'')+'.'); return; }
    if(f.id==='newsForm'){
      const v=($('#newsEmail')||{}).value||'';
      if(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v.trim())){ const t=$('#newsOk'); if(t) f.replaceWith(t.content.cloneNode(true)); }
      else { const m=$('#formMsg'); if(m) m.textContent=L('news_err','That email doesn’t look right. Check it and try again.'); }
      return;
    }
    if(f.id==='contactForm'){
      if(!f.checkValidity()){ f.reportValidity(); return; }
      const t=$('#contactOk'); if(t) f.replaceWith(t.content.cloneNode(true));
    }
  });

  /* floating buy pill: shows between the hero and the buy section */
  const bar=$('#buybar'), hero=$('#hero'), buy=$('#buy');
  if(bar&&hero&&'IntersectionObserver' in window){
    const vis={hero:true,buy:false};
    const io=new IntersectionObserver(es=>{
      es.forEach(en=>{ vis[en.target.id]=en.isIntersecting; });
      const show=!vis.hero&&!vis.buy;
      bar.classList.toggle('show',show); bar.setAttribute('aria-hidden',String(!show)); bar.inert=!show;
    },{threshold:0});
    io.observe(hero); if(buy) io.observe(buy);
    bar.inert=true;
  }

  /* the size guide marks the collar that is selected */
  $$('#popSize .guide-t tbody tr').forEach((r,i)=>{ r.dataset.c=['DM','DL','C'][i]||''; });

  renderPacks(); renderCollars(); fillPrices(); syncTag(); syncCal(); refresh(); updLit(); onScroll();
  if(ONTAG&&location.hash==='#buy'&&qc) setTimeout(()=>{ const b=$('#buy'); if(b) b.scrollIntoView({behavior:'auto'}); },60);
})();